import request from '@/common/api'
import { HOSTS } from '@/common/utils/env'
import { selector, useRecoilValueLoadable, atom, useSetRecoilState } from 'recoil'


type ConfigRes = {
  /** 账户余额预警信息 */
  accountBalanceAlert?: {
    /** 是否有预警 */
    alert: boolean;
    /** 预警信息 */
    msg: string | null;
  };
  /** 财务管理是否显示红点角标（从 accountBalanceAlert.alert 派生） */
  financialBadge?: boolean;
}


const FETCH_KEY = '/api/entweb/ent/aggregateQuery'

// 刷新触发器
const refreshTrigger = atom({
  key: `${FETCH_KEY}_refresh_trigger`,
  default: 0,
})


const getData = selector({
  key: FETCH_KEY,
  get: async ({ get }) => {
    get(refreshTrigger)
    const data = await request.get<ConfigRes>(`${HOSTS.BASE}${FETCH_KEY}`)

    // 将 accountBalanceAlert.alert 映射为 financialBadge
    const result: ConfigRes = {
      accountBalanceAlert: data?.accountBalanceAlert,
      financialBadge: data?.accountBalanceAlert?.alert || false,
    }

    return result
  },
})


const aggregateQueryAtom = {
  useRefresh: () => {
    const setRefreshTrigger = useSetRecoilState(refreshTrigger)

    return () => {
      // 增加计数器值触发刷新
      setRefreshTrigger(count => count + 1)
    }
  },
  useData: () => {
    const loadable = useRecoilValueLoadable(getData)
    const result =  loadable.state === 'hasValue' ? loadable.contents : {}
    return result as ConfigRes
  },
}

export default aggregateQueryAtom